import {
	ApiRequestContextData,
	GetApplicationHeadersOptions,
} from "@utils/api-config/types";
import { getCurrentLanguage } from "@utils/common/culture";
import { DeviceDetector } from "@utils/common/DeviceDetector";

import { isCapacitorPlatform } from "@utils/specific/capacitor/helpers";

export function getMvcRequestHeaders(
	context: ApiRequestContextData | null,
	options: GetApplicationHeadersOptions = { shouldSetToken: true }
) {
	const { shouldSetToken = true } = options;

	const headers: Record<string, string> = {
		"Accept-Language": getCurrentLanguage(),
		"Caller-Environment": WEBPACK_ENVIRONMENT_KEY,
		"Agency-Key": WEBPACK_DEFAULT_AGENCY_KEY,
	};

	let webDeviceValue = WEBPACK_ENVIRONMENT_KEY;

	if (isCapacitorPlatform()) {
		webDeviceValue = "CapacitorApp";
	} else if (DeviceDetector.isMobileApp) {
		webDeviceValue = "Mobile";
	}
	headers["Web-Device" as keyof HeadersInit] = webDeviceValue;

	if (!context) {
		return headers;
	}

	if (context.agencyId) {
		headers["Agency-Id"] = context.agencyId;
	}
	if (context.agencyKey) {
		headers["Agency-Key"] = context.agencyKey;
	}
	if (shouldSetToken && context.authToken) {
		headers["Authorization"] = `Bearer ${context.authToken}`;
	}
	if (context.shopId) {
		headers["Shop-Id"] = context.shopId;
	}

	return headers;
}
